import dynamic from 'next/dynamic';
import { EcondaWidgetCredentials } from '@frontastic-engbers/types/engbers-custom';
const EcondaSlider = dynamic(() => import('@engbers/components/online-shops/econda/econda-slider').then(module => module.EcondaSlider), {
  ssr: false
});
export const EcondaSliderTastic = ({
  data
}) => {
  const econdaWidgetConfiguration: EcondaWidgetCredentials = data?.econdaWidgetConfiguration?.dataSource.credentials;
  return <EcondaSlider config={econdaWidgetConfiguration} widgetId={data.widgetId} title={data.title} textSize={data.textSize} isStartPage={data.isStartPage} data-sentry-element="EcondaSlider" data-sentry-component="EcondaSliderTastic" data-sentry-source-file="index.tsx" />;
};